// eslint-disable-next-line import/prefer-default-export
export const filterModalType = {
  A: 1,
  B: 2,
  C: 3,
  D: 4,
  E: 5, // eventWindow
  F: 6,
  G: 7,
};
